import axios from "./httpClient"

export default class Api {
  static async request(url, body, cancelToken, method = body ? "post" : "get") {
    return axios
      .request({
        url,
        method,
        cancelToken,
        data: body
      })
      .then((response) => response.data)
  }

  static async postForm(url, formData, config) {
    return axios
      .request({
        url,
        method: "post",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data"
        },
        ...config
      })
      .then((response) => response.data)
  }
}
